import { render, staticRenderFns } from "./CaliforniaPrivacyNoticeView.vue?vue&type=template&id=4bb6d3ca&scoped=true"
import script from "./CaliforniaPrivacyNoticeView.vue?vue&type=script&lang=js"
export * from "./CaliforniaPrivacyNoticeView.vue?vue&type=script&lang=js"
import style0 from "./CaliforniaPrivacyNoticeView.vue?vue&type=style&index=0&id=4bb6d3ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6d3ca",
  null
  
)

export default component.exports